import { useEffect, useState } from "react";
import api from "./axiosConfig";
import { getToken } from "./auth";

export function usePurchases() {
  const loggedIn = Boolean(getToken());
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(loggedIn);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!loggedIn) {
      setOrders([]);
      setLoading(false);
      return undefined;
    }

    let cancelled = false;
    setLoading(true);
    api
      .get("/payments/mine")
      .then((res) => {
        if (cancelled) return;
        setOrders(res.data.orders || []);
        setError("");
      })
      .catch(() => {
        if (!cancelled) setError("Unable to load your orders.");
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [loggedIn]);

  const purchasedIds = new Set(orders.map((order) => String(order.course_id)));

  return {
    loggedIn,
    orders,
    loading,
    error,
    isPurchased: (courseId) => purchasedIds.has(String(courseId)),
  };
}
